@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.collapsible-list-item-header {
  display: flex;
  flex-direction: row;
  background: @collapsable-list--header--background-color;
  cursor: pointer;
  font-size: 14px;
  overflow: hidden;
  color: @collapsable-list--header--text-color;
  width: 100%;
  text-align: left;
  border-radius: inherit;

  &.white {
    background: @collapsable-list--header--light--background-color;
    font-weight: @semi-bold;
  }

  &.disabled {
    opacity: 0.5;
    cursor: default;
  }

  &.no-outline {
    &:focus {
      outline: none;
    }
  }
}

.expander-header-content {
  display: flex;
  flex: 1;
  padding: 0 10px;
}

.open-chevron {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  transition: all 300ms ease;
  margin-left: -6px;

  &.vertical {
    transform: rotate(90deg);

    &.open {
      transform: rotate(-90deg);
    }
  }

  &.open {
    transform: rotate(90deg);
  }

  > svg {
    fill: @collapsable-list-header--chevron--icon-color;
    height: 18px;
  }
}

.open-border {
  border-bottom: 1px solid @collapsable-list--header--border-color;
}

.collapsible-list-item-header-content {
  flex: 1;
  display: inline-flex;
  align-items: center;
}

.expander-action {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.group-grabber {
  display: flex;
  align-items: center;
  width: 24px;
}

.group-grabber-icon {
  width: 24px;
  color: var(--gray-637381);
}

.summary-data {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: @collapsable-list-header--summary--text-color;
  padding-left: 10px;
  padding-right: 5px;
  font-size: 12px;
  font-weight: 300;
}

.inactive {
  &:hover {
    cursor: default;
  }
  .open-chevron {
    padding: 20px 5px;
    width: unset;
  }
}
